const translation = {
	name: 'Название',
	Table: {
		noRecords: 'Записей не найдено',
	},
};

export default { translation };
